<app-auth-navbar></app-auth-navbar>
<main class="rtl">
    <!-- <div class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div class="absolute top-0 w-full h-full bg-center bg-cover">
            <span class="bg-primary w-full h-full absolute" id="blackOverlay"></span>
        </div>
        <div class="container relative mx-auto">
            <div class="items-center flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                    <div class="">
                        <h1 class="text-white font-semibold text-5xl leading-normal">
                            استاد ویزیت، سامانه ویزیت و مشاوره آنلاین پزشکی
                        </h1>
                        <div class="relative flex w-full flex-wrap items-stretch mt-12"><span
                                class="z-10 h-full leading-snug font-normal text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"><i
                                    class="fa fa-search"></i></span><input type="text"
                                placeholder=" نام پزشک، نام بیماری، تخصص ... "
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded shadow  w-full pl-10">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="bg-primary absolute top-0 w-full h-20 bg-center bg-cover">
        <span class="w-full h-full absolute" id="blackOverlay"></span>
    </div>

    <section class="pt-32 py-16 main-bg">
        <div class="container mx-auto px-4">
            <div class="flex flex-wrap">
                <div class="w-full lg:w-6/12 xl:w-8/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 shadow-lg">
                        <div class="flex justify-center">
                            <h5 class="font-semibold text-2xl my-4"> اطلاعات شخصی: </h5>
                        </div>
                        <hr>
                        <div class="bg-primary-light text-primary my-4 p-4">
                            <div class="flex justify-around my-2 p-2">
                                <p> نام و نام خانوادگی: </p>
                                <p> {{visit.patientFullName}} </p>
                            </div>
                            <div class="flex justify-around my-2 p-2">
                                <p>  کد ملی: </p>
                                <p> {{visit.nationalCode}} </p>
                            </div>
                            <div class="flex justify-around my-2 p-2">
                                <p>  شماره تماس: </p>
                                <p> {{visit.patientMobile}} </p>
                            </div>
                        </div>
                        <hr>
                        <div>
                            <p class="my-4"> شما در تاریخ
                                 <span class="text-secondary"> {{(visit.visitDate|shamsiDate)}} </span>
                                  ساعت
                                   <span class="text-secondary"> {{convertUTCMinutesToLocal(visit.startVisit)!='00:00'?convertUTCMinutesToLocal(visit.startVisit):'---'}} </span>
                                   یک ویزیت
                                    <span class="text-secondary" *ngIf="visit.visitType==visitTypess.VideoVisit"> تصویری </span>
                                    <span class="text-secondary" *ngIf="visit.visitType==visitTypess.BodyVisit"> حضوری </span>
                                    <span class="text-secondary" *ngIf="visit.visitType==visitTypess.PhoneVisit"> صوتی </span>
                                    <span class="text-secondary" *ngIf="visit.visitType==visitTypess.TextVisit"> متنی </span>
                                    با دکتر
                                    <span class="text-secondary"> {{visit.doctorFullName}} </span>
                                     را انتخاب کردید. </p>
                            <p class="my-6">  
                                
                                <input type="checkbox" name="" id="accept" class="border-gray-300 px-2 py-2 rounded" [(ngModel)]="isAccepted">
                               <label for="accept"> من با <a class="text-primary" routerLink="/terms"> قوانین و مقررات </a>  موافق هستم. </label>
                            </p>
                        </div>
                    </div>


                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="my-4 text-center">
                            <h5 class="font-semibold"> پیش فاکتور </h5>
                        </div>                        
                        <hr>
                        <div class="flex justify-between my-2 p-2">
                            <p> ویزیت {{visit.visitType==visitTypess.TextVisit?'متنی':visit.visitType==visitTypess.PhoneVisit?'صوتی':visit.visitType==visitTypess.VideoVisit?'تصویری':visit.visitType==visitTypess.BodyVisit?'حضوری':null}} </p>
                            <p> {{visit.price| number:''}} تومان </p>
                        </div>
                        <div class="flex justify-between my-2 p-2">
                            <p>  تخفیف </p>
                            <p> {{visit.discount| number:''}} تومان </p>
                        </div>
                        <div class="flex justify-between my-2 mb-4 p-2 bg-primary-light">
                            <p> مبلغ قابل پرداخت </p>
                            <p> {{visit.price-visit.discount| number:''}} تومان </p>
                        </div>
                        <hr>
                        <div class="my-2 p-2 ">
                            <input type="checkbox" name="" id="wallet" class="border-gray-300 px-2 py-2 rounded" [(ngModel)]="isEnough" [disabled]="disableWallet()">
                               <label for="wallet"> برداشت از کیف پول </label>
                            <!-- <input type="checkbox" value="" [disabled]="" class="sr-only peer">
  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div> -->
                        </div>
                        <div class="flex justify-between my-2 p-2">
                            <p>  موجودی </p>
                            <p> {{visit.walletBalance| number:''}} تومان </p>
                        </div>
                        
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-full rounded-lg py-3 mb-1 disabled:cursor-not-allowed disabled:bg-gray-200"
                                type="button" (click)="payVisit()" name=""> پرداخت 
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>


</main>
<app-footer></app-footer>